import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ContractsList from "@/components/contracts/ContractsList";

export default function HostContracts() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/contracts").then(({ data }) => setList(data.contracts)).catch(() => setList([])); }, []);
  return (
    <div className="space-y-4" data-testid="host-contracts">
      <div>
        <div className="label-eyebrow text-[var(--ff-red)] mb-1">▮ CONFIDENTIAL</div>
        <p className="text-sm text-[var(--ff-text-dim)]">Agreements sent to you by management. Only you, the other signers, Executive Managers and the Founder can see them.</p>
      </div>
      <ContractsList contracts={list} empty="No contracts yet. When management sends you one, it appears here and the bot DMs you." />
    </div>
  );
}
